import React from 'react';

const DAY_NAMES = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];

// Delivered + skipped meals for one member, newest first. Used by the customer
// calendar and by the admin's per-member history popup.
const MealHistory = ({ subscription }) => {
    const history = [
        ...(subscription?.deliveredMeals || []).map(m => ({ ...m, status: 'Delivered' })),
        ...(subscription?.skippedMeals || []).map(m => ({ ...m, status: 'Skipped' }))
    ].sort((a, b) => new Date(b.date) - new Date(a.date));

    if (history.length === 0) {
        return <p className="text-gray-500 text-sm p-4 text-center">No previous history available.</p>;
    }

    return (
        <div className="overflow-x-auto rounded-xl border border-gray-200 custom-scrollbar">
            <table className="min-w-full divide-y divide-gray-200 text-left text-sm">
                <thead className="bg-gray-50 whitespace-nowrap">
                    <tr>
                        <th className="px-4 py-3 font-medium text-gray-500 uppercase tracking-wider">Date</th>
                        <th className="px-4 py-3 font-medium text-gray-500 uppercase tracking-wider">Day</th>
                        <th className="px-4 py-3 font-medium text-gray-500 uppercase tracking-wider">Period</th>
                        <th className="px-4 py-3 font-medium text-gray-500 uppercase tracking-wider">Meal Delivered</th>
                        <th className="px-4 py-3 font-medium text-gray-500 uppercase tracking-wider">Status</th>
                    </tr>
                </thead>
                <tbody className="bg-white divide-y divide-gray-100">
                    {history.map((record, i) => (
                        <tr key={i} className="hover:bg-gray-50 transition-colors">
                            <td className="px-4 py-3 font-bold text-gray-700 whitespace-nowrap">{record.date}</td>
                            <td className="px-4 py-3 text-gray-600">{record.day || DAY_NAMES[new Date(record.date).getDay()]}</td>
                            <td className="px-4 py-3 text-gray-600">{record.period}</td>
                            <td className="px-4 py-3 text-gray-700">
                                {subscription?.mealsGiven?.find(mg => mg.date === record.date && mg.period === record.period)?.meal
                                    || <span className="text-gray-300">—</span>}
                            </td>
                            <td className="px-4 py-3 whitespace-nowrap">
                                <span className={`inline-flex px-2 py-0.5 rounded text-xs font-bold border ${record.status === 'Delivered' ? 'bg-blue-50 text-blue-700 border-blue-200 shadow-sm' : 'bg-red-50 text-red-700 border-red-200 opacity-80'}`}>
                                    {record.status}
                                </span>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default MealHistory;
